import { jsPDF } from "jspdf";

// Testo predefinito con segnaposto {{...}} sostituiti al momento della firma.
export const DEFAULT_PAGES = [
`CONVENZIONE DI OSPITALITÀ
e Regolamento essenziale della struttura

Il presente documento disciplina in modo chiaro i principali aspetti del soggiorno, i servizi compresi nella retta, le regole di convivenza e le modalità di comunicazione tra struttura, ospite e familiari.

1. PARTI E DATI DEL SOGGIORNO
Società / Gestore: {{societa}}
Struttura: {{struttura}}
Ospite: {{ospite}}
Nato/a a - il: {{natoA}}
Codice fiscale: {{cf}}
Familiare / Referente: {{familiare}}
Data di ingresso: {{dataIngresso}}

Le parti convengono e stipulano quanto segue.

2. RETTA MENSILE E MODALITÀ DI PAGAMENTO
• La retta mensile di soggiorno è pari a € {{retta}} e deve essere corrisposta anticipatamente entro il giorno 5 di ogni mese, salvo diverso accordo scritto.
• La retta è dovuta per la disponibilità del posto e per l'insieme dei servizi organizzati dalla struttura. Le assenze temporanee dell'ospite, quando non dipendono da cause imputabili alla struttura, non comportano automaticamente riduzioni o rimborsi.
• Qualora l'ospite si assenti temporaneamente mantenendo il posto in struttura, la retta mensile resta dovuta per intero.
• Disdetta del soggiorno: comunicazione scritta con preavviso di almeno 15 (quindici) giorni. In mancanza del preavviso, potrà essere richiesto il pagamento della retta relativa al periodo di mancato preavviso.
• In caso di decesso dell'ospite, l'eventuale conguaglio o rimborso della retta sarà regolato secondo la clausola economica sottoscritta.

Clausola economica in caso di decesso
• Decesso entro il giorno 5 del mese: rimborso del 50% della retta mensile già corrisposta.
• Decesso successivo al giorno 5 del mese: la retta del mese resta dovuta e non è previsto rimborso.

3. SERVIZI COMPRESI NELLA RETTA
• assistenza generale alla persona secondo il livello assistenziale previsto dalla struttura;
• vitto con i consueti pasti giornalieri e bevande previste dal servizio;
• pulizia ordinaria della camera e degli ambienti di pertinenza;
• servizio di lavanderia ordinaria, secondo le modalità interne;
• attività ricreative, sociali e di animazione organizzate dalla struttura;
• supporto quotidiano nelle normali esigenze di vita comunitaria.`,

`4. SERVIZI E SPESE NON COMPRESI
Restano a carico dell'ospite, del familiare o del soggetto obbligato al pagamento, salvo diverso accordo scritto: visite e prestazioni specialistiche, prestazioni infermieristiche aggiuntive non comprese nel servizio ordinario, fisioterapia, parrucchiere, pedicure/podologia, telefono, trasporti o accompagnamenti extra e ogni altra prestazione non espressamente indicata tra i servizi compresi.

5. DOCUMENTAZIONE SANITARIA ALL'INGRESSO
All'ingresso dovrà essere consegnata la documentazione sanitaria necessaria a consentire una corretta presa in carico dell'ospite, compresa l'attestazione medica relativa allo stato generale di salute e, ove richiesta, all'assenza di condizioni contagiose incompatibili con la vita comunitaria, oltre a cartelle cliniche, terapie in corso, prescrizioni e ogni informazione sanitaria utile.

6. ASSISTENZA, TERAPIE E FARMACI
• Le indisposizioni lievi o di breve durata possono essere gestite nella camera dell'ospite, compatibilmente con le condizioni cliniche e con l'organizzazione assistenziale.
• I medicinali destinati agli ospiti sono custoditi in spazi protetti e non liberamente accessibili.
• Le terapie vengono gestite sulla base delle prescrizioni sanitarie disponibili e delle procedure interne della struttura.
• In caso di necessità sanitaria, la struttura attiva i riferimenti medici e/o i servizi sanitari competenti secondo il livello di urgenza e le procedure previste.

7. GIORNATA TIPO DELL'OSPITE
Gli orari hanno valore indicativo e possono essere adattati alle esigenze degli ospiti e all'organizzazione della struttura.
07:00 - 09:30   Risveglio, igiene e preparazione della giornata
09:00 circa       Colazione
10:00 - 12:00   Attività ricreative, socializzazione, passeggiate o attività di gruppo
12:00 - 14:00   Pranzo e assistenza
14:00 - 15:00   Riposo
15:00 circa       Merenda
Dalle 16:00      Attività ricreative, canto, passeggiate, ginnastica dolce e giochi
18:30 circa       Cena
Dopo cena        Relax, televisione e attività tranquille
21:00 circa       Preparazione al riposo notturno`,

`8. USCITE, VISITE E VITA COMUNITARIA
• Le visite di familiari e conoscenti sono consentite secondo le modalità organizzative della struttura, nel rispetto della tranquillità degli altri ospiti e delle esigenze assistenziali.
• Le uscite dell'ospite devono essere compatibili con le sue condizioni e con le indicazioni organizzative e sanitarie applicabili. Quando necessario, la struttura potrà richiedere che l'uscita sia concordata con il familiare o referente.
• Gli ospiti e i visitatori sono invitati a rispettare gli orari dei pasti, del riposo e le normali regole di convivenza.

9. DENARO, OGGETTI PERSONALI E VALORI
La struttura invita a non lasciare denaro, gioielli o altri oggetti di valore incustoditi. La gestione e l'eventuale custodia di valori dovranno essere concordate con la Direzione. La struttura non può garantire il rimborso di beni lasciati incustoditi o non affidati secondo le procedure previste.

10. COMPORTAMENTO E CESSAZIONE DEL SOGGIORNO
Cessazione ordinaria da parte della struttura: preavviso scritto di almeno 60 (sessanta) giorni, senza necessità di indicare una specifica motivazione, fatti salvi gli obblighi inderogabili di legge. Durante il preavviso l'ospite continua a usufruire dei servizi e la retta resta dovuta.
Cessazione per gravi motivi comportamentali: preavviso scritto di almeno 15 (quindici) giorni. A titolo esemplificativo: comportamenti aggressivi, violenti o minacciosi; gravi e reiterati litigi; comportamenti che compromettano serenità, sicurezza o convivenza; reiterata inosservanza delle regole; situazioni sopravvenute non più compatibili con il livello di assistenza erogabile.

11. MISURE DI SICUREZZA E PROTEZIONE DELL'OSPITE
Eventuali sponde del letto, cinture di sicurezza per carrozzine o altre misure di protezione non sono automatiche. Il loro impiego potrà avvenire soltanto quando effettivamente necessario, sulla base della valutazione del caso, delle indicazioni sanitarie e delle procedure applicabili, con adeguata informazione al familiare/referente e relativa documentazione.
Presa visione / autorizzazione ove richiesta: ______________________________`,

`12. IMMAGINI, FOTO E COMUNICAZIONE
L'eventuale utilizzo di fotografie o video dell'ospite per raccontare attività, ricorrenze o eventi della struttura deve essere oggetto di una scelta separata e specifica. Il mancato consenso non incide in alcun modo sulla qualità dell'assistenza o sui servizi ricevuti.
Consenso pubblicazione foto/video — Canali interni della struttura: SÌ [ ]  NO [ ]
Consenso pubblicazione foto/video — Sito / social / piattaforme digitali: SÌ [ ]  NO [ ]

13. MENÙ E ALIMENTAZIONE
Il menù giornaliero è organizzato dalla Direzione della struttura. Eventuali esigenze alimentari specifiche, diete prescritte, allergie o intolleranze devono essere comunicate e documentate affinché possano essere gestite secondo le possibilità e le procedure della struttura.

14. COMUNICAZIONI E RIFERIMENTI
Referente struttura — Telefono: {{referenteTel}}   E-mail: {{referenteEmail}}
Familiare/referente principale: {{familiare}}

15. ACCETTAZIONE
L'ospite e/o il familiare/referente dichiara di aver ricevuto il presente documento, di averne letto il contenuto e di aver potuto richiedere chiarimenti prima della sottoscrizione.`,
];

const applyTemplate = (tpl, c) => (tpl || "").replace(/\{\{(\w+)\}\}/g, (_, k) => {
  const v = c[k];
  return (v === undefined || v === null || v === "") ? (k === "retta" ? "________" : "—") : String(v);
});

export const conventionPages = (c, templates) => {
  const src = (Array.isArray(templates) && templates.length === 4 && templates.some((t) => t && t.trim())) ? templates : DEFAULT_PAGES;
  return src.map((t) => applyTemplate(t, c));
};

export async function generateSignedPdf(c, sigOspite, sigFamiliare, templates, logo = "") {
  const pages = conventionPages(c, templates);
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 14;
  let y = 22;
  const header = () => {
    doc.setFillColor(31, 122, 92); doc.rect(0, 0, W, 15, "F");
    doc.setTextColor(255, 255, 255); doc.setFont("helvetica", "bold"); doc.setFontSize(9.5);
    doc.text(`${(c.societa || "STRUTTURA").toUpperCase()} — CONVENZIONE DI OSPITALITÀ`, M, 9.5);
    if (logo) {
      try {
        const props = doc.getImageProperties(logo);
        const ratio = props.width && props.height ? props.width / props.height : 1;
        let lh = 11, lw = lh * ratio;
        if (lw > 30) { lw = 30; lh = lw / ratio; }
        const lx = W - M - lw, ly = (15 - lh) / 2;
        doc.setFillColor(255, 255, 255); doc.roundedRect(lx - 1.5, ly - 1, lw + 3, lh + 2, 1.5, 1.5, "F");
        doc.addImage(logo, (props.fileType || "PNG"), lx, ly, lw, lh);
      } catch (e) { /* ignora */ }
    }
    doc.setTextColor(30, 30, 30); y = 22;
  };
  const LH = 4.05;
  const bottomLimit = H - 14; // lascia spazio al footer

  // Scrive tutto il testo con impaginazione automatica (nessun testo tagliato).
  pages.forEach((txt, idx) => {
    if (idx > 0) doc.addPage();
    header();
    doc.setFont("helvetica", "normal"); doc.setFontSize(8.3);
    const lines = doc.splitTextToSize(txt, W - 2 * M);
    lines.forEach((ln) => {
      if (y + LH > bottomLimit) { doc.addPage(); header(); doc.setFont("helvetica", "normal"); doc.setFontSize(8.3); }
      const bold = /^\d+\.\s/.test(ln) || ln.startsWith("CONVENZIONE DI OSPITALITÀ") || ln.startsWith("Clausola");
      doc.setFont("helvetica", bold ? "bold" : "normal");
      doc.text(ln, M, y); y += LH;
    });
  });

  // Blocco firme: subito dopo il testo; se non c'è spazio, nuova pagina.
  const boxH = 26;
  const sigNeeded = boxH + 18;
  if (y + sigNeeded > bottomLimit) { doc.addPage(); header(); }
  let by = y + 10;
  doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(30, 30, 30);
  doc.text(`Luogo e data: ${c.luogoData || ""}`, M, by - 3);
  doc.setDrawColor(150);
  if (c.soloOspite) {
    const boxW = 100, x1 = (W - boxW) / 2;
    doc.rect(x1, by, boxW, boxH);
    try { if (sigOspite) doc.addImage(sigOspite, "PNG", x1 + 2, by + 2, boxW - 4, boxH - 4); } catch (e) {}
    const ly = by + boxH + 4;
    doc.setFontSize(8); doc.setFont("helvetica", "bold");
    doc.text(`Ospite (autonomo): ${c.ospite || ""}`, x1, ly);
    doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(120, 120, 120);
    doc.text(`Documento firmato digitalmente il ${c.firmatoIl || ""}`, M, ly + 5);
  } else {
    const boxW = 82, x1 = M, x2 = W - M - boxW;
    doc.rect(x1, by, boxW, boxH); doc.rect(x2, by, boxW, boxH);
    try { if (sigOspite) doc.addImage(sigOspite, "PNG", x1 + 2, by + 2, boxW - 4, boxH - 4); } catch (e) {}
    try { if (sigFamiliare) doc.addImage(sigFamiliare, "PNG", x2 + 2, by + 2, boxW - 4, boxH - 4); } catch (e) {}
    const ly = by + boxH + 4;
    doc.setFontSize(8); doc.setFont("helvetica", "bold");
    doc.text(`Ospite: ${c.ospite || ""}`, x1, ly);
    doc.text(c.firmatarioLabel || "Familiare / Referente / avente titolo", x2, ly);
    doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(120, 120, 120);
    doc.text(`Documento firmato digitalmente il ${c.firmatoIl || ""}`, M, ly + 5);
  }

  // Footer con numerazione dinamica su tutte le pagine effettive.
  const total = doc.getNumberOfPages();
  for (let i = 1; i <= total; i++) {
    doc.setPage(i);
    doc.setFontSize(7.5); doc.setTextColor(150);
    doc.text(`Pagina ${i} di ${total} — Documento per ospite/familiare`, W / 2, H - 6, { align: "center" });
    doc.setTextColor(30, 30, 30);
  }
  return doc.output("blob");
}
